import { Observable } from 'rxjs';
import { SalesTeamMultiSelectConfig } from '../filters/salesteam-multi-select/tokens';
import { PackageSelectConfig } from '../filters/package-selector/tokens';
import { ProductSelectorConfig } from '../filters/product-selector/tokens';
import { TagMultiSelectConfig } from '../filters/tag-selector/tokens';
import { PipelineConfig } from './interfaces';

export function defaultCurrencyCodeFactory(config: PipelineConfig): Observable<string> {
  return config.defaultCurrency$;
}

export function pipelineSettingsURLFactory(config: PipelineConfig): string {
  return config.pipelineSettingsURL;
}

export function pipelineSettingsAccessFactory(config: PipelineConfig): Observable<boolean> {
  return config.pipelineSettingsAccess$;
}

export function packageSelectConfigFactory(config: PipelineConfig): PackageSelectConfig {
  return {
    partnerId$: config.partnerId$,
    marketId$: config.marketId$,
  };
}

export function salesTeamMultiSelectConfigFactory(config: PipelineConfig): SalesTeamMultiSelectConfig {
  return {
    partnerId$: config.partnerId$,
    marketId$: config.marketId$,
    salesTeamsService: config.salesTeamsService,
  };
}

export function productSelectorConfigFactory(config: PipelineConfig): ProductSelectorConfig {
  return {
    products$: config.products$,
  };
}

export function tagMultiSelectConfigFactory(config: PipelineConfig): TagMultiSelectConfig {
  return {
    marketId$: config.marketId$,
    partnerId$: config.partnerId$,
    tagService: config.tagService,
  };
}
